import {
    registration,
    registrationApplication,
    registrationApprovalPending,
    registrationConfirmEmail,
    registrationDeclined,
    registrationInterests,
    registrationLocalCommunitySelect,
    registrationMembership,
    registrationCreatorOffer,
    registrationPhoneNumber,
    registrationPhoto,
    profileCompletionStart,
    start,
    eventWallPreview,
} from '@routes/catalog'
import { useINAppRouter } from '@routes/utils/useINAppRouter'
import { logError } from '@util/logger'
import safelySerializeWithType from '@util/safelySerializeWithType'
import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useCallback } from 'react'

export const STEP_MAP = {
    basic_registration: registration,
    application_pending: registrationApplication,
    approval_pending: registrationApprovalPending,
    localcommunity_selection: registrationLocalCommunitySelect,
    email_unconfirmed: registrationConfirmEmail,
    phone_number: registrationPhoneNumber,
    declined: registrationDeclined,
    registered: registrationPhoto,
    photo: registrationPhoto,
    photo_submitted: registrationInterests,
    interest: registrationInterests,
    interests_submitted: registrationMembership,
    splashpage: registrationMembership,
    creator_offer: registrationCreatorOffer,
    profile_completion: profileCompletionStart,
    event_wall: eventWallPreview,
    end: start,
} as const

export const isInStepMap = (moveTo: string | null | undefined): moveTo is keyof typeof STEP_MAP =>
    moveTo != null && moveTo in STEP_MAP

export const FALLBACK_ROUTE = start

const moveToWorkflowStep = (
    moveTo: string | null | undefined,
    go: (route: TRoute, navigationOptions?: NavigateOptions) => void
): void => {
    if (!isInStepMap(moveTo)) {
        logError(`Invalid workflow step: ${safelySerializeWithType(moveTo)}`, {
            metadata: { moveTo, caller: 'moveToWorkflowStep' },
        })
        go(FALLBACK_ROUTE)
        return
    }

    go(STEP_MAP[moveTo])
}

export const useNavigateWorkflow = (): ((data?: TWorkflowData) => void) => {
    const { go } = useINAppRouter()

    return useCallback(
        (data?: TWorkflowData) => {
            const { canAccess, moveTo } = data ?? {}

            if (canAccess || moveTo === null) {
                const preamble = moveTo === null ? `No workflow step` : `Cannot access step`
                logError(`${preamble}. Not navigating anywhere.`, {
                    metadata: { canAccess, moveTo, caller: 'useNavigateWorkflow', workflowData: data },
                })

                return
            }

            moveToWorkflowStep(moveTo, go)
        },
        [go]
    )
}
